export enum RateAgreementState {
  Active = 0,
  Pending = 1,
  Expired = 2,
}

export enum RateAgreementStateDisplayName {
  A = 0,
  P = 1,
  E = 2,
}

export function GetRateAgreementStateDisplayName(state: RateAgreementState) {
  return RateAgreementStateDisplayName[state];
}

export const rateAgreementStateAsString = new Map([
  [RateAgreementState.Active, "A"],
  [RateAgreementState.Pending, "P"],
  [RateAgreementState.Expired, "E"],
]);
